export const questions = {
  "Brand Positioning": [
    {
      text: "Potential customers immediately understand what makes us different from competitors.",
      options: ["Yes", "Sometimes", "No"],
      values: [2, 1, 0]
    },
    {
      text: "Our brand attracts our ideal customers and repels the wrong ones.",
      options: ["Yes", "Somewhat", "No"],
      values: [2, 1, 0]
    },
    {
      text: "Our visual brand (logo, colours, photos) looks as professional as our premium competitors.",
      options: ["Yes", "Getting there", "No"],
      values: [2, 1, 0]
    }
  ],
  "Website Performance": [
    {
      text: "Our website clearly communicates our unique value within 5 seconds.",
      options: ["Yes", "Unclear", "No"],
      values: [2, 1, 0]
    },
    {
      text: "Visitors can easily book consultations, trials, or purchases without friction.",
      options: ["Multiple easy options", "One option", "Difficult"],
      values: [2, 1, 0]
    },
    {
      text: "Our website generates qualified leads consistently every week.",
      options: ["Yes", "Occasionally", "Rarely"],
      values: [2, 1, 0]
    },
    {
      text: "Our website showcases client results and testimonials prominently.",
      options: ["Yes, prominently", "Some buried", "Missing"],
      values: [2, 1, 0]
    }
  ],
  "Marketing System": [
    {
      text: "We have a consistent content strategy that positions us as the expert.",
      options: ["Yes, consistent", "Sporadic", "No strategy"],
      values: [2, 1, 0]
    },
    {
      text: "We have automated systems to nurture leads into paying customers.",
      options: ["Fully automated", "Some automation", "All manual"],
      values: [2, 1, 0]
    },
    {
      text: "We track which marketing activities bring in the most valuable customers.",
      options: ["Yes, clearly", "Rough idea", "No tracking"],
      values: [2, 1, 0]
    }
  ]
};